/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Entity
 */
export type VerifyUserMobileNoBySMSRequestEntity = typeof VerifyUserMobileNoBySMSRequestEntity[keyof typeof VerifyUserMobileNoBySMSRequestEntity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifyUserMobileNoBySMSRequestEntity = {
  User: 'User',
} as const;
